module.exports = __webpack_public_path__ + "img/Recurso 23@300xt.4d854e7e.webp";